<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
      :loading="false"
  >
    <template #customLayoutContent>
      <div class="d-flex flex-stack bg-white mt-10 p-5 mx-10 card shadow-sm mb-5">
        <ActionsBar :query="query" :showSearch="showSearch" :handleRangeDate="handleRangeDate"/>
      </div>

      <KanbanView ref="kanbanComponent" :filter="query" v-if="route.query.viewType === modelViewType.kanban" />
      <PrevisionView ref="previsionComponent" :filter="query" v-else-if="route.query.viewType === modelViewType.prevision" />
      <ListView ref="defaultComponent" :filter="query" v-else />
    </template>
  </SubLayout>


</template>
<script setup>
import {onBeforeMount, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRoute } from 'vue-router'
import {useModelViewType} from "@/composables/modelViewType";
import ListView from './components/List.vue'
import KanbanView from './components/Kanban.vue'
import PrevisionView from './components/Prevision.vue'
import ActionsBar from "@/Modules/CRM/views/Pipeline/components/ActionsBar";

const store = useStore()
const route = useRoute()
const { modelViewType } = useModelViewType()
const showSearch = ref(false)

const emits = defineEmits(['opportunityCreated'])

const title = ref( "crm.pipeline.title")
const breadcrumbs = ref([
  {
    name: 'crm.pipeline.opportunityList',
    path: '/admin'
  }
])
const query = ref({
  startDate: '',
  endDate: '',
  search: '',
  status: '',
  contact: '',
  year: new Date(),
  counter: 0,
  seller: '',
  priority: ''
})
const kanbanComponent = ref()
const previsionComponent = ref()
const defaultComponent= ref()

function handleRangeDate (range) {
  query.value.startDate = range.start_date
  query.value.endDate = range.end_date
}

watch(() => route.query.viewType, (value) => {
  if (value === modelViewType.value.list) showSearch.value = false
  else showSearch.value = true
})

onBeforeMount(() => {
  if(!route.query.viewType) {
    route.query.viewType = modelViewType.value.kanban
  }
})

function loadData() {
  Promise.all([
    store.dispatch('company/generalInformation'),
    store.dispatch('pipelines/loadPipelineStatusEnum'),
    store.dispatch('pipelines/loadPipelinePrioritiesEnum'),
    store.dispatch('contacts/loadContacts'),
    store.dispatch('pipelines/loadSalesPersons')
  ])
}

onMounted(() => {
  loadData()
  showSearch.value = route.query.viewType === modelViewType.value.list ? false : true
})


</script>
